module.exports = __webpack_public_path__ + "static/img/CgoRC2RCTZGAIyXCAASzcbpQxQo559.b436cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2RCTZGAIyXCAASzcbpQxQo559.png
// module id = zTmF
// module chunks = 73